import { ToolPanelDef } from '@ag-grid-community/core'
import {
  WorkbenchColumnManagerComponent,
  WorkbenchColumnManagerParams,
} from './workbench-column-manager.component'

export const WORKBENCH_COLUMN_MANAGER_ID = 'workbenchColumnManager'

/**
 * Sidebar entry for the workbench Column Manager.
 *
 * This replaces ag-Grid's built-in `agColumnsToolPanel` (used by `heliosDefaultToolPanels`) because
 * the 2.0 design calls for something it does not offer: a Pick face grouping columns by their
 * column source in the server's group order with visible/total counts, and a separate Reorder face
 * that is a flat drag list tagged by group.
 *
 * Params are passed as thunks because the catalog is fetched per source and per account: the panel
 * re-reads them on every rebuild rather than capturing one source's grouping at construction.
 */
export function createWorkbenchColumnManagerToolPanel(
  params: WorkbenchColumnManagerParams,
): ToolPanelDef {
  return {
    id: WORKBENCH_COLUMN_MANAGER_ID,
    labelDefault: 'Columns',
    labelKey: 'columns',
    iconKey: 'columns',
    toolPanelFramework: WorkbenchColumnManagerComponent,
    toolPanelParams: params,
  }
}
